// react
import styled from 'styled-components';

// components
import { Loader } from '@/components/atoms';

interface LoadingProps {
  className?: string;
  isEasterEgg?: boolean;
}
/**
 * Loading is a component that renders a loading page.
 */
export const Loading = ({ className, isEasterEgg }: LoadingProps) => {
  return (
    <Wrapper>
      <Loader className={className} isEasterEgg={isEasterEgg} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

Loading.displayName = 'Loading';

export default Loading;
